import { Organization } from "../organization";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterVolunteer } from "../call-center-volunteer";
import { CallCenterVolunteerGroupEntityConfig } from "./config";
import { CallCenterVolunteerGroupFilters } from "./filters";
import { CallCenterVolunteerGroupMethods } from "./methods";

@HyperEntity<CallCenterVolunteerGroup>(
  "call-center-volunteer-group",
  CallCenterVolunteerGroupEntityConfig,
)
export class CallCenterVolunteerGroup extends extender(
  CallCenterVolunteerGroupFilters,
  CallCenterVolunteerGroupMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Relations.toMany(() => CallCenterVolunteer, "groupId")
  volunteers?: CallCenterVolunteer[];

  @Fields.string({ caption: "שם" })
  name = "";

  @Fields.string({ caption: "הערות" })
  notes = "";

  @Fields.string({ dbName: "contact_name", caption: "איש קשר" })
  contactName = "";

  @Fields.string({ dbName: "contact_phone", caption: "טלפון איש קשר" })
  contactPhone = "";

  @Fields.boolean({ dbName: "is_active", caption: "פעיל" })
  isActive = true;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
